import { Button, Form, Input, InputNumber, Modal, Switch } from 'antd';
import React, { useEffect } from 'react';
import useAuthRequest from '../../../services/requests.service';
import { toast } from 'react-toastify';

const FilterModal = ({ currentFilter, isModalOpen, setIsModalOpen, setFilters, filters, handleClose }) => {
    const request = useAuthRequest();
    const [form] = Form.useForm();

    useEffect(() => {
        if (currentFilter) {
            form.setFieldsValue({
                name: currentFilter.name || '',
                fr: currentFilter.translations?.fr || '',
                active: currentFilter.active === 1,
                position: currentFilter.position || 0,
            });
        } else {
            form.resetFields();
        }
    }, [currentFilter, form]);

    const handleCancel = () => {
        setIsModalOpen(false);
        handleClose();
    };

    const afterClose = () => {
        form.resetFields();
    };

    const onFinish = async (values) => {
        const payload = {
            name: values.name,
            translations: { fr: values.fr },
            active: values.active ? 1 : 0,
            position: values.position || 0,
        };

        try {
            if (!currentFilter) {
                const res = await request.postDataAPI('filters', payload);
                setFilters([...filters, res.newFilter]);
                toast.success(res.msg);
            } else {
                const res = await request.patchDataAPI(`filters/${currentFilter._id}`, payload);
                setFilters(filters.map((f) => (f._id === currentFilter._id ? res.updatedFilter : f)));
                toast.success(res.msg);
            }
            setIsModalOpen(false);
        } catch (error) {
            toast.error(error?.msg || 'Une erreur est survenue');
        }
    };

    return (
        <Modal
            centered
            footer={null}
            open={isModalOpen}
            onCancel={handleCancel}
            afterClose={afterClose}
            title={currentFilter ? 'Modifier le filtre' : 'Créer un filtre'}
        >
            <Form
                form={form}
                onFinish={onFinish}
                layout="vertical"
                className="mt-4"
            >
                <Form.Item
                    label="Nom (clé interne)"
                    name="name"
                    rules={[{ required: true, message: 'Le nom est requis' }]}
                >
                    <Input size="large" placeholder="ex: restaurant" />
                </Form.Item>

                <Form.Item
                    label="Traduction (FR)"
                    name="fr"
                    rules={[{ required: true, message: 'La traduction est requise' }]}
                >
                    <Input size="large" placeholder="ex: Restaurant" />
                </Form.Item>

                <div className="flex gap-4">
                    <Form.Item label="Position" name="position" className="flex-1">
                        <InputNumber size="large" className="w-full" min={0} />
                    </Form.Item>

                    <Form.Item label="Actif" name="active" valuePropName="checked">
                        <Switch />
                    </Form.Item>
                </div>

                <Form.Item className="flex justify-end mb-0 mt-4">
                    <Button onClick={handleCancel} className="mr-2">Annuler</Button>
                    <Button size="large" type="primary" htmlType="submit">
                        {currentFilter ? 'Mettre à jour' : 'Créer'}
                    </Button>
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default FilterModal;
